// extracted by mini-css-extract-plugin
export default {"btn":"searchComponent_btn__IaBS-","input-container":"searchComponent_input-container__baxaf","toggle-pass":"searchComponent_toggle-pass__+l0RJ"};